/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent, memo } from "react";

type Props = {
  className?: string;
};

const Logo: FunctionComponent<Props> = ({ className }) => {
  return (
    <svg
      className={clsx("block", className)}
      viewBox="0 0 279 51"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="m49.46 5.41 1.528-2.294c10.927 4.348 18.09 13.126 18.09 22.674 0 4.726-1.513 8.206-2.482 9.924-1.208 2.146-2.388 3.327-4.461 3.327H28.54c-8.299 0-12.068-5.155-8.374-11.496 3.447-5.917 10.786-16.021 14.893-21.121 2.03-2.52 1.403-2.934-.517-2.934-16.062 0-28.794 10.551-28.794 22.3 0 12.744 11.243 21.967 29.012 21.967 7.352 0 15.954-1.359 22.544-7.313h5.836c-6.772 7.67-18.699 10.404-28.43 10.404C12.696 50.848.488 38.75.488 25.79c0-14.077 14.079-25 34.273-25 3.992 0 8.7.326 11.614 1.103 2.846.761 2.198 2.292 1.404 3.268C42.35 11.83 33.55 22.918 30.613 28.713c-1.642 3.255-.555 4.556 3.106 4.556h26.855c2.162 0 3.266-3.705 3.266-7.804 0-8.195-4.137-15.843-14.38-20.055Zm197.965 18.542h22.781c11.405 0 11.472 15.099.051 15.099h-65.746c-5.117 0-10.738-4.133-10.738-8.47V16.583l-14.687 9.251 18.081 13.216h-13.896l-11.653-8.516-13.513 8.516h-65.79c-9.558 0-13.806-4.888-13.806-12.664V14.144h9.43v14.398c0 3.637 1.737 5.577 5.458 5.577h19.738c1.075-2.964 3.008-5.645 5.539-7.275h-6.271c.796-7.057 7.66-12.698 17.32-12.698h33.364l11.596 8.472 13.454-8.474h15.05s.004 11.095.004 14.826c0 3.096 1.754 5.1 5.932 5.1h15.584V14.144h9.39v19.932s27.333-.013 31.192-.013c3.74 0 3.74-5.22-.135-5.22h-28.215c0-5.31 3.144-14.699 16.354-14.699h23.174v4.892h-21.798c-4.239 0-6.506 2.004-7.244 4.916ZM124.491 34.12h31.93l10.798-6.801-15.025-10.978v2.707h-20.935c-4.745 0-6.798 2.865-7.253 4.879h26.344v4.87h-19.792c-4.357 0-5.74 2.654-6.067 5.323Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const LexusLogo = memo(Logo);
